var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCopy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 20,
    viewBox: "0 0 17 20",
    fill: "currentCollor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.3206 0H1.74163C0.783732 0 0 0.783732 0 1.74163V13.0622C0 13.5411 0.391866 13.933 0.870813 13.933C1.34976 13.933 1.74163 13.5411 1.74163 13.0622V2.61244C1.74163 2.13349 2.13349 1.74163 2.61244 1.74163H11.3206C11.7995 1.74163 12.1914 1.34976 12.1914 0.870813C12.1914 0.391866 11.7995 0 11.3206 0ZM14.8038 3.48325H5.22488C4.26699 3.48325 3.48325 4.26699 3.48325 5.22488V17.4163C3.48325 18.3742 4.26699 19.1579 5.22488 19.1579H14.8038C15.7617 19.1579 16.5455 18.3742 16.5455 17.4163V5.22488C16.5455 4.26699 15.7617 3.48325 14.8038 3.48325ZM13.933 17.4163H6.09569C5.61675 17.4163 5.22488 17.0244 5.22488 16.5455V6.09569C5.22488 5.61675 5.61675 5.22488 6.09569 5.22488H13.933C14.412 5.22488 14.8038 5.61675 14.8038 6.09569V16.5455C14.8038 17.0244 14.412 17.4163 13.933 17.4163Z",
    fill: "currentcolor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopy);
export default __webpack_public_path__ + "static/media/copy.a504f18d1a006ac478fe73dea0afdc5a.svg";
export { ForwardRef as ReactComponent };